import React, { useEffect } from 'react';
import { FieldValues, FormProvider, SubmitHandler, useForm, UseFormProps } from 'react-hook-form';

export function Form<TFieldValues extends FieldValues = FieldValues>({
    children,
    onSubmit,
    ...useFormProps
}: UseFormProps<TFieldValues> & {
    children: React.ReactNode | React.ReactNode[];
    onSubmit: SubmitHandler<TFieldValues>;
}): JSX.Element {
    const methods = useForm<TFieldValues>(useFormProps);

    const firstErrorKey = Object.keys(methods.formState.errors).find((key) => methods.formState.errors[key]);
    const inputElement = document.querySelector(`input[name="${firstErrorKey}"]`) as HTMLInputElement | null;
    useEffect(() => {
        if (firstErrorKey) {
            inputElement?.scrollIntoView();
        }
    }, [firstErrorKey, inputElement, methods.formState.errors]);

    return (
        <FormProvider {...methods}>
            <form
                noValidate
                onSubmit={methods.handleSubmit(async (values) => {
                    await onSubmit(values);
                    methods.reset(values);
                })}
            >
                {children}
            </form>
        </FormProvider>
    );
}

export * from './FormTextField';
export * from './FormDatePicker';
export * from './FormSelect';
export * from './FormAutocomplete';
export * from './FormCheckbox';
export * from './FormCheckboxGroup';
export * from './FormRadioGroup';
export * from './FormButton';
export * from './form-types';
export * from './react-hook-form-exposed-utils';
